import React from 'react'
import { connect } from 'react-redux'

import classnames from 'classnames'

import Map, {
    DEFAULT_LNG,
    DEFAULT_LAT,
    ZOOM_LEVEL,
} from '../../../components/shared/map'

import Autocomplete from 'react-google-autocomplete'
import Configurator from '../../../configurator'
import { i18n } from '../../../validator'
import Loader from '../../../front/components/shared/loader'

@i18n()
class AutocompleteRow extends Configurator {
    render = () => {
        const {
            type,
            handleLocationChange,
            loadingMap,
            t,
        } = this.props

        if (!(window && window.google) || loadingMap) {
            return (
                <div className="form-group">
                    <Loader />
                </div>
            )
        }

        return (
            <div className="form-group">
                <label className={classnames({
                    'd-block': type === 'user_defined',
                    'd-none': type !== 'user_defined',
                })}>
                    {t('locationHelperText')} <small className="text-danger">{t('requiredInBrackets')}</small>
                </label>
                <AutocompleteRaw
                    type={type}
                    onPlaceSelected={place => handleLocationChange(place)}
                    placeholder={t('autoCompleteLocationPlaceholder')}
                />
            </div>
        )
    }
}

export const AutocompleteRaw = props => {
    const {
        onPlaceSelected,
        placeholder,
        className,
        locationTypes,
        type,
        value,
        onChange,
    } = props

    return (
        <Autocomplete
            onPlaceSelected={place => onPlaceSelected(place)}
            types={locationTypes || []}
            placeholder={placeholder}
            className={className || classnames({
                'form-control': true,
                'd-block': type === 'user_defined',
                'd-none': type !== 'user_defined',
            })}
            value={value}
            onChange={onChange}
        />
    )
}

export default connect(state => ({ loadingMap: state.app.loadingMap }))(AutocompleteRow)

export const MapRow = props => (
    <Map
        markers={props.marker ? [props.marker] : null}
        options={{
            center: {
                lat: DEFAULT_LAT,
                lng: DEFAULT_LNG,
            },
            zoom: ZOOM_LEVEL,
            maxZoom: null,
            scrollwheel: false,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
        }}
        fitBounds={true}
        boundsSize={0.0005}
        className="min-height-200"
    />
)
